/* tslint:disable */
/* eslint-disable */
/**
 * Shopping Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NotificationResponse } from './NotificationResponse';
import {
    NotificationResponseFromJSON,
    NotificationResponseFromJSONTyped,
    NotificationResponseToJSON,
    NotificationResponseToJSONTyped,
} from './NotificationResponse';

/**
 * Réponse de la validation du panier emprunteur. Retourne le premier emprunteur/devis pour la redirection vers la contractualisation.
 * @export
 * @interface ValidatePanierEmprunteurResponse
 */
export interface ValidatePanierEmprunteurResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidatePanierEmprunteurResponse
     */
    isSuccess: boolean;
    /**
     * Identifiant du premier emprunteur (pour la redirection)
     * @type {string}
     * @memberof ValidatePanierEmprunteurResponse
     */
    borrowerId?: string;
    /**
     * Identifiant du premier devis créé (pour la redirection)
     * @type {string}
     * @memberof ValidatePanierEmprunteurResponse
     */
    quoteId?: string;
    /**
     * Message d'erreur en cas d'échec
     * @type {string}
     * @memberof ValidatePanierEmprunteurResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {NotificationResponse}
     * @memberof ValidatePanierEmprunteurResponse
     */
    notification?: NotificationResponse;
}

/**
 * Check if a given object implements the ValidatePanierEmprunteurResponse interface.
 */
export function instanceOfValidatePanierEmprunteurResponse(value: object): value is ValidatePanierEmprunteurResponse {
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    return true;
}

export function ValidatePanierEmprunteurResponseFromJSON(json: any): ValidatePanierEmprunteurResponse {
    return ValidatePanierEmprunteurResponseFromJSONTyped(json, false);
}

export function ValidatePanierEmprunteurResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatePanierEmprunteurResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'],
        'borrowerId': json['borrowerId'] == null ? undefined : json['borrowerId'],
        'quoteId': json['quoteId'] == null ? undefined : json['quoteId'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'notification': json['notification'] == null ? undefined : NotificationResponseFromJSON(json['notification']),
    };
}

export function ValidatePanierEmprunteurResponseToJSON(json: any): ValidatePanierEmprunteurResponse {
    return ValidatePanierEmprunteurResponseToJSONTyped(json, false);
}

export function ValidatePanierEmprunteurResponseToJSONTyped(value?: ValidatePanierEmprunteurResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'borrowerId': value['borrowerId'],
        'quoteId': value['quoteId'],
        'errorMessage': value['errorMessage'],
        'notification': NotificationResponseToJSON(value['notification']),
    };
}

